function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9427 0C15.914 0 9.319 6.40385 8.60215 14.2308H0V26.6115C0.286738 32.4462 5.30466 37 11.4695 37C15.7706 37 19.6416 34.5808 21.5054 31.0231C22.3656 31.1654 23.2258 31.3077 24.2294 31.3077C32.8315 31.3077 39.5699 25.0462 40 16.7923V0H23.9427ZM11.4695 34.1538C6.73835 34.1538 3.01075 30.7385 2.86738 26.4692V17.0769H8.60215H11.4695H11.6129C16.2007 17.0769 20.0717 20.9192 20.0717 25.6154C20.0717 26.3269 19.9283 27.0385 19.7849 27.75C19.4982 28.7462 19.2115 29.6 18.638 30.3115C17.0609 32.5885 14.4803 34.1538 11.4695 34.1538ZM37.1326 16.65C36.7025 23.3385 31.2545 28.4615 24.2294 28.4615C23.6559 28.4615 23.0824 28.4615 22.6523 28.3192C22.9391 27.4654 22.9391 26.4692 22.9391 25.6154C22.9391 19.3538 17.9211 14.2308 11.6129 14.2308H11.4695C12.1864 7.96923 17.491 2.84615 23.9427 2.84615H37.1326V16.65Z",
  fill: "currentColor"
});

var SvgIcProductCatSlVhis = function SvgIcProductCatSlVhis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcProductCatSlVhis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_product_cat_sl_vhis.d8ef92f1.svg";
export { ForwardRef as ReactComponent };